import Keycloak from 'keycloak-js'

const getRealmFromDomain = () => {
  const domain = window.location.hostname
  const realmPrefix = domain.split('.')[0]
  return `${realmPrefix}-realm`
}

const getClientIdFromDomain = () => {
  const domain = window.location.hostname
  const clientIdPrefix = domain.split('.')[0]
  return `${clientIdPrefix}reactapp`
}

const keycloakConfig = {
  realm: `${process.env.REACT_APP_KEYCLOAK_REALM || getRealmFromDomain()}`,
  url: `${process.env.REACT_APP_KEYCLOAK_URL}`,
  clientId: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID || getClientIdFromDomain()}`,
}

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(keycloakConfig)

export default keycloak